import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import NoCard from '../../assets/NoCard.svg';
import ApplePay from '../../assets/ApplePay.svg';

import './PaymentOption.scss';

interface Props {
    rtl: boolean;
    handlePaymentOptionChange: any;
    selectRadioOption: string;
}

const win: any = window;

const PaymentOption = ({ handlePaymentOptionChange, selectRadioOption }: Props) => {
    const { t } = useTranslation();

    const [showApplePay, setShowApplePay] = useState(true);

    useEffect(() => {
        if (typeof win.ApplePaySession === "undefined") {
            setShowApplePay(false);
            return;
        }
        setShowApplePay(false);

        if (typeof win?.ApplePaySession !== "undefined" && win?.ApplePaySession) {
            const merchantIdentifier = win.merchId;
            console.log("merchantIdentifier: ", merchantIdentifier);

            win.ApplePaySession?.canMakePaymentsWithActiveCard(merchantIdentifier)
                .then((canMakePayments: boolean) => {
                    console.log("canMakePayments:", canMakePayments);
                    setShowApplePay(canMakePayments);
                }).catch(() => {
                    setShowApplePay(false);
                });
        }
    }, []);

    return (
        <div className='Payment__Method'>
            <div
                onClick={() => handlePaymentOptionChange("card")}
                className={selectRadioOption === 'card' ? "payment-method-row active" : "payment-method-row"}
            >
                <div className='custom-card-icon'>
                    <img src={NoCard} alt="Nocard" className='nocard' />
                </div>
                <span>{t('Card')}</span>
            </div>

            {showApplePay && (
                <div
                    id="apple-pay"
                    onClick={() => handlePaymentOptionChange("applePay")}
                    className={selectRadioOption === 'applePay' ? "payment-method-row active" : "payment-method-row"}
                >
                    <div className='custom-card-icon'>
                        <img src={ApplePay} alt="ApplePay" />
                    </div>
                    <span>{t('ApplePay')}</span>
                </div>
            )}
        </div>
    )
}

export default PaymentOption;